import { AssetManager } from "../AssetManager";
import { Enemy } from "../models/Enemy";
import { Game } from "../logic/Game";
import { Effect } from "../models/Effect";
import { GameView } from "./GameView";

export class EffectsView {
    public constructor(
        public game: Game,
        protected assets: AssetManager,
        protected game_view: GameView,
        protected context: CanvasRenderingContext2D,
    ) {

    }

    public update() {
        this.context.imageSmoothingEnabled = false;
        this.game.effects.forEach((effect: Effect) => {
            const image = this.get_effect_image(effect);
            const position = effect.position;

            this.context.drawImage(image,
                position[0] * this.game_view.field_width,
                position[1] * this.game_view.field_height,
                this.game_view.field_width,
                this.game_view.field_height
            );
        })
    }

    public get_effect_image(effect: Effect): HTMLImageElement {
        return this.assets.get("effects.fire");
    }

}